<div class="auth">
  <div class="auth_left">
    <div class="card">
      <div class="text-center mb-2">
        <img class="mainheader" src="../assets/images/mslogo.png" />
      </div>
      <div class="card-body">
        <div class="card-title">Login to your account</div>
        <form class="form" [formGroup]="form">
          <div class="form-group">
            <label class="form-label" for="username">Username</label>
            <input
              tabindex="1"
              id="username"
              type="text"
              class="form-control"
              formControlName="username"
              placeholder="Username"
              required
            />
            <div
              class="alert alert-danger"
              *ngIf="
                form?.get('username')?.touched && form?.get('username')?.invalid
              "
            >
              <div *ngIf="form?.get('username')?.errors?.required">
                Username is required
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label"
              >Password
              <a
                tabindex="3"
                [routerLink]="['/forgot-password']"
                href="javascript:void(0)"
                class="float-right small"
                >I forgot password</a
              ></label
            >
            <input
              tabindex="2"
              type="password"
              class="form-control"
              placeholder="Password"
              formControlName="password"
              required
            />
            <div
              class="alert alert-danger"
              *ngIf="
                form?.get('password')?.touched && form?.get('password')?.invalid
              "
            >
              <div *ngIf="form?.get('password')?.errors?.required">
                Password is required
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="custom-control custom-checkbox">
              <input
                type="checkbox"
                tabindex="4"
                class="custom-control-input"
              />
              <span class="custom-control-label">Remember me</span>
            </label>
          </div>
          <div class="form-footer">
            <button
              class="btn btn-primary btn-block"
              title="Signin"
              type="submit"
              (click)="submitLoginForm()"
            >
              Sign in
            </button>
          </div>
        </form>
      </div>
      <div class="text-center text-muted">
        Don't have account yet?
        <a [routerLink]="['/register']" href="javascript:void(0)"
          >Contact Admin</a
        >
      </div>
    </div>
  </div>
  <div class="auth_right">
    <carousel [isAnimated]="true">
      <slide>
        <img
          src="assets/images/slider1.jpg"
          class="img-fluid"
          alt="first slide"
        />
        <div class="px-4 mt-4">
          <!-- <h4>Fully Responsive</h4> -->
        </div>
      </slide>
      <slide>
        <img
          src="assets/images/slider2.jpg"
          class="img-fluid"
          alt="second slide"
        />
        <div class="px-4 mt-4">
          <!-- <h4>Quality Code and Easy Customizability</h4> -->
        </div>
      </slide>
      <slide>
        <img
          src="assets/images/slider3.jpg"
          class="img-fluid"
          alt="third slide"
        />
        <div class="px-4 mt-4">
          <!-- <h4>Cross Browser Compatibility</h4> -->
        </div>
      </slide>
    </carousel>
  </div>
</div>
